import React from "react";

const JudgesList = ({ judges, t, isQuadMode }) => {
  const getJudgeTypeLabel = (judgeType) => {
    switch (judgeType) {
      case 'primary':
        return t.primary_judge;
      case 'sanitary':
        return t.sanitary_judge;
      case 'regular':
        return t.regular_judge;
      default:
        return t.judge;
    }
  };

  const getJudgeTypeIcon = (judgeType) => {
    switch (judgeType) {
      case 'primary':
        return 'fa-user-tie';
      case 'sanitary':
        return 'fa-user-check';
      case 'regular':
        return 'fa-user';
      default:
        return 'fa-user';
    }
  };

  // Сортировка судей: сначала обычные, потом первичные, затем санитарные
  const sortedJudges = [...judges].sort((a, b) => {
    const order = { regular: 0, primary: 1, sanitary: 2 };
    return order[a.judge_type] - order[b.judge_type];
  });

  const renderJudgeCard = (judge) => {
    const judgeType = judge.judge_type;
    
    return (
      <div key={judge.id} className={`judge-card-column ${judgeType}`}>
        <div className="judge-type-label">
          {/* <i className={`fa-solid ${getJudgeTypeIcon(judgeType)} me-1`}></i> */}
          {getJudgeTypeLabel(judgeType)}
        </div>
        <div className="judge-name-column">
          <div className="judge-last-name">{judge.last_name} {judge.first_name}</div>
        </div>
        <div className="judge-photo-column">
          {judge.photo_url ? (
            <img
              src={judge.photo_url}
              alt={judge.full_name}
              className="judge-photo-img"
            />
          ) : (
            <div className="judge-photo-placeholder">
              <i className={`fa-solid ${getJudgeTypeIcon(judgeType)}`}></i>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className={`judges-list-container ${isQuadMode ? 'quad-mode' : ''}`}>
      {/* <h3 className="judges-list-title">{t.judges_title}</h3> */}
      
      <div className="judges-unified-grid">
        {sortedJudges.map((judge) => renderJudgeCard(judge))}
      </div>
    </div>
  );
};

export default JudgesList;
